var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a-card",
        { attrs: { bordered: false, title: "结转参数设置" } },
        [
          _c(
            "a-tabs",
            {
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "a-tab-pane",
                { key: "set", attrs: { tab: "账套配置" } },
                [
                  _c(
                    "a-form",
                    {
                      staticStyle: { "margin-bottom": "12px" },
                      attrs: { layout: "inline" },
                    },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "账套" } },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "260px" },
                              attrs: {
                                "show-search": "",
                                "option-filter-prop": "children",
                              },
                              on: { change: _vm.onAccountSetChange },
                              model: {
                                value: _vm.accountSetId,
                                callback: function ($$v) {
                                  _vm.accountSetId = $$v
                                },
                                expression: "accountSetId",
                              },
                            },
                            _vm._l(_vm.accountSets, function (s) {
                              return _c(
                                "a-select-option",
                                { key: s.id, attrs: { value: s.id } },
                                [_vm._v(_vm._s(s.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("a-alert", {
                    staticStyle: { "margin-bottom": "12px" },
                    attrs: {
                      type: "info",
                      "show-icon": "",
                      message:
                        "结转参数为账套级配置：测算税率/附加率与取数科目、各卡片凭证模板行（多行，支持一借多贷/多借一贷）。建账时已从系统默认按账套会计准则复制，此后独立演化。",
                    },
                  }),
                  _vm._l(_vm.groups, function (g) {
                    return _c(
                      "div",
                      { key: g.title, staticStyle: { "margin-bottom": "8px" } },
                      [
                        _c("a-divider", { attrs: { orientation: "left" } }, [
                          _vm._v(_vm._s(g.title)),
                        ]),
                        _c(
                          "a-row",
                          { attrs: { gutter: 16 } },
                          _vm._l(g.fields, function (f) {
                            return _c(
                              "a-col",
                              {
                                key: f.key,
                                staticStyle: { "margin-bottom": "8px" },
                                attrs: { md: 12, sm: 24 },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      width: "200px",
                                      "text-align": "right",
                                      "padding-right": "8px",
                                    },
                                  },
                                  [_vm._v(_vm._s(f.label) + "：")]
                                ),
                                f.type === "subject"
                                  ? _c(
                                      "a-select",
                                      {
                                        staticStyle: {
                                          width: "calc(100% - 208px)",
                                          "min-width": "180px",
                                        },
                                        attrs: {
                                          "show-search": "",
                                          "option-filter-prop": "children",
                                          "allow-clear": "",
                                          placeholder: "选择科目",
                                        },
                                        model: {
                                          value: _vm.form[f.key],
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, f.key, $$v)
                                          },
                                          expression: "form[f.key]",
                                        },
                                      },
                                      _vm._l(_vm.leafSubjects, function (s) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: s.subjectName,
                                            attrs: { value: s.subjectName },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(s.subjectCode) +
                                                " " +
                                                _vm._s(s.subjectName)
                                            ),
                                          ]
                                        )
                                      }),
                                      1
                                    )
                                  : _c("a-input-number", {
                                      staticStyle: {
                                        width: "calc(100% - 208px)",
                                        "min-width": "180px",
                                      },
                                      attrs: {
                                        min: 0,
                                        max: 100,
                                        step: 0.01,
                                        formatter: _vm.percentFormatter,
                                        parser: _vm.percentParser,
                                        placeholder: "百分比",
                                      },
                                      model: {
                                        value: _vm.form[f.key],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, f.key, $$v)
                                        },
                                        expression: "form[f.key]",
                                      },
                                    }),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.saving },
                      on: { click: _vm.save },
                    },
                    [_vm._v("保存参数")]
                  ),
                  _c("a-divider", { attrs: { orientation: "left" } }, [
                    _vm._v("凭证模板（结转卡片凭证行）"),
                  ]),
                  _c(
                    "a-form",
                    {
                      staticStyle: { "margin-bottom": "8px" },
                      attrs: { layout: "inline" },
                    },
                    [
                      _c(
                        "a-form-item",
                        { attrs: { label: "结转卡片" } },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "240px" },
                              on: { change: _vm.pickTemplateCard },
                              model: {
                                value: _vm.templateCardKey,
                                callback: function ($$v) {
                                  _vm.templateCardKey = $$v
                                },
                                expression: "templateCardKey",
                              },
                            },
                            _vm._l(_vm.templateCards, function (c) {
                              return _c(
                                "a-select-option",
                                { key: c.key, attrs: { value: c.key } },
                                [_vm._v(_vm._s(c.name))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c("a-button", { on: { click: _vm.addTemplateLine } }, [
                        _vm._v("加行"),
                      ]),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { loading: _vm.savingTemplate },
                          on: { click: _vm.saveTemplate },
                        },
                        [_vm._v("保存模板")]
                      ),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-left": "8px" },
                          on: { click: _vm.resetTemplate },
                        },
                        [_vm._v("重置为系统默认")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { color: "#999", "margin-bottom": "8px" } },
                    [
                      _vm._v(
                        "「自动」行按测算键在结账向导中预填金额（可改）；「手工」行由用户在生成时填写。科目为编码优先解析、名称回退。"
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "scroll-wrap",
                      style: {
                        maxHeight: _vm.scrollHeight + "px",
                        overflowY: "auto",
                      },
                    },
                    [
                      _c("table", { staticClass: "gl-tpl-table" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticStyle: { width: "70px" } }, [
                              _vm._v("方向"),
                            ]),
                            _c("th", [_vm._v("科目")]),
                            _c("th", [_vm._v("摘要")]),
                            _c("th", { staticStyle: { width: "70px" } }, [
                              _vm._v("来源"),
                            ]),
                            _c("th", { staticStyle: { width: "60px" } }, [
                              _vm._v("操作"),
                            ]),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.templateLines, function (line, idx) {
                            return _c("tr", { key: idx }, [
                              _c(
                                "td",
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: { size: "small" },
                                      model: {
                                        value: line.direction,
                                        callback: function ($$v) {
                                          _vm.$set(line, "direction", $$v)
                                        },
                                        expression: "line.direction",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "借" } },
                                        [_vm._v("借")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "贷" } },
                                        [_vm._v("贷")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        size: "small",
                                        "show-search": "",
                                        "option-filter-prop": "children",
                                        placeholder: "选择科目",
                                      },
                                      model: {
                                        value: line.subjectId,
                                        callback: function ($$v) {
                                          _vm.$set(line, "subjectId", $$v)
                                        },
                                        expression: "line.subjectId",
                                      },
                                    },
                                    _vm._l(_vm.leafSubjects, function (s) {
                                      return _c(
                                        "a-select-option",
                                        { key: s.id, attrs: { value: s.id } },
                                        [
                                          _vm._v(
                                            _vm._s(s.subjectCode) +
                                              " " +
                                              _vm._s(s.subjectName)
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                [
                                  _c("a-input", {
                                    attrs: {
                                      size: "small",
                                      placeholder: "摘要",
                                    },
                                    model: {
                                      value: line.summary,
                                      callback: function ($$v) {
                                        _vm.$set(line, "summary", $$v)
                                      },
                                      expression: "line.summary",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  line.calc_key
                                    ? _c(
                                        "a-tag",
                                        { attrs: { color: "blue" } },
                                        [_vm._v("自动")]
                                      )
                                    : _c("a-tag", [_vm._v("手工")]),
                                ],
                                1
                              ),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _c("a-icon", {
                                    staticStyle: {
                                      color: "#f5222d",
                                      cursor: "pointer",
                                    },
                                    attrs: { type: "delete" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeTemplateLine(idx)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ]
                  ),
                ],
                2
              ),
              _vm.isSuperAdmin
                ? _c(
                    "a-tab-pane",
                    { key: "system", attrs: { tab: "系统默认配置" } },
                    [
                      _c("a-alert", {
                        staticStyle: { "margin-bottom": "12px" },
                        attrs: {
                          type: "warning",
                          "show-icon": "",
                          message:
                            "系统默认模板（tenant_id=0）仅超级管理员可维护：修改只影响此后新建的账套，存量账套不受影响（可在账套配置中主动「重置为系统默认」）。",
                        },
                      }),
                      _c(
                        "a-form",
                        {
                          staticStyle: { "margin-bottom": "8px" },
                          attrs: { layout: "inline" },
                        },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "会计准则" } },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  on: { change: _vm.loadSystemTemplate },
                                  model: {
                                    value: _vm.systemStandard,
                                    callback: function ($$v) {
                                      _vm.systemStandard = $$v
                                    },
                                    expression: "systemStandard",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio",
                                    { attrs: { value: "小企业会计准则" } },
                                    [_vm._v("小企业会计准则")]
                                  ),
                                  _c(
                                    "a-radio",
                                    { attrs: { value: "企业会计准则" } },
                                    [_vm._v("企业会计准则")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.groups, function (g) {
                        return _c(
                          "div",
                          {
                            key: g.title,
                            staticStyle: { "margin-bottom": "8px" },
                          },
                          [
                            _c(
                              "a-divider",
                              { attrs: { orientation: "left" } },
                              [_vm._v(_vm._s(g.title))]
                            ),
                            _c(
                              "a-row",
                              { attrs: { gutter: 16 } },
                              _vm._l(g.fields, function (f) {
                                return _c(
                                  "a-col",
                                  {
                                    key: f.key,
                                    staticStyle: { "margin-bottom": "8px" },
                                    attrs: { md: 12, sm: 24 },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          display: "inline-block",
                                          width: "200px",
                                          "text-align": "right",
                                          "padding-right": "8px",
                                        },
                                      },
                                      [_vm._v(_vm._s(f.label) + "：")]
                                    ),
                                    _c("a-input", {
                                      staticStyle: {
                                        width: "calc(100% - 208px)",
                                        "min-width": "180px",
                                      },
                                      attrs: {
                                        placeholder:
                                          f.type === "subject"
                                            ? "科目名称"
                                            : "如 0.12",
                                      },
                                      model: {
                                        value: _vm.systemForm[f.key],
                                        callback: function ($$v) {
                                          _vm.$set(_vm.systemForm, f.key, $$v)
                                        },
                                        expression: "systemForm[f.key]",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _c(
                        "a-button",
                        {
                          attrs: { type: "primary", loading: _vm.savingSystem },
                          on: { click: _vm.saveSystem },
                        },
                        [_vm._v("保存参数")]
                      ),
                      _c("a-divider", { attrs: { orientation: "left" } }, [
                        _vm._v("凭证模板（系统默认）"),
                      ]),
                      _c(
                        "a-form",
                        {
                          staticStyle: { "margin-bottom": "8px" },
                          attrs: { layout: "inline" },
                        },
                        [
                          _c(
                            "a-form-item",
                            { attrs: { label: "结转卡片" } },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { width: "240px" },
                                  on: { change: _vm.pickSystemTemplateCard },
                                  model: {
                                    value: _vm.systemTemplateCardKey,
                                    callback: function ($$v) {
                                      _vm.systemTemplateCardKey = $$v
                                    },
                                    expression: "systemTemplateCardKey",
                                  },
                                },
                                _vm._l(_vm.systemTemplateCards, function (c) {
                                  return _c(
                                    "a-select-option",
                                    { key: c.key, attrs: { value: c.key } },
                                    [_vm._v(_vm._s(c.name))]
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-button",
                            { on: { click: _vm.addSystemTemplateLine } },
                            [_vm._v("加行")]
                          ),
                          _c(
                            "a-button",
                            {
                              staticStyle: { "margin-left": "8px" },
                              attrs: { loading: _vm.savingSystemTemplate },
                              on: { click: _vm.saveSystemTemplate },
                            },
                            [_vm._v("保存模板")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "scroll-wrap",
                          style: {
                            maxHeight: _vm.scrollHeight + "px",
                            overflowY: "auto",
                          },
                        },
                        [
                          _c("table", { staticClass: "gl-tpl-table" }, [
                            _c("thead", [
                              _c("tr", [
                                _c("th", { staticStyle: { width: "70px" } }, [
                                  _vm._v("方向"),
                                ]),
                                _c("th", { staticStyle: { width: "120px" } }, [
                                  _vm._v("科目编码"),
                                ]),
                                _c("th", { staticStyle: { width: "200px" } }, [
                                  _vm._v("科目名称"),
                                ]),
                                _c("th", [_vm._v("摘要")]),
                                _c("th", { staticStyle: { width: "70px" } }, [
                                  _vm._v("来源"),
                                ]),
                                _c("th", { staticStyle: { width: "60px" } }, [
                                  _vm._v("操作"),
                                ]),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(
                                _vm.systemTemplateLines,
                                function (line, idx) {
                                  return _c("tr", { key: idx }, [
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "a-select",
                                          {
                                            staticStyle: { width: "100%" },
                                            attrs: { size: "small" },
                                            model: {
                                              value: line.direction,
                                              callback: function ($$v) {
                                                _vm.$set(line, "direction", $$v)
                                              },
                                              expression: "line.direction",
                                            },
                                          },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "借" } },
                                              [_vm._v("借")]
                                            ),
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "贷" } },
                                              [_vm._v("贷")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            size: "small",
                                            placeholder: "如 560201",
                                          },
                                          model: {
                                            value: line.subject_code,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                line,
                                                "subject_code",
                                                $$v
                                              )
                                            },
                                            expression: "line.subject_code",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            size: "small",
                                            placeholder: "如 工资",
                                          },
                                          model: {
                                            value: line.subject_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                line,
                                                "subject_name",
                                                $$v
                                              )
                                            },
                                            expression: "line.subject_name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      [
                                        _c("a-input", {
                                          attrs: {
                                            size: "small",
                                            placeholder: "摘要",
                                          },
                                          model: {
                                            value: line.summary,
                                            callback: function ($$v) {
                                              _vm.$set(line, "summary", $$v)
                                            },
                                            expression: "line.summary",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "text-align": "center" },
                                      },
                                      [
                                        line.calc_key
                                          ? _c(
                                              "a-tag",
                                              { attrs: { color: "blue" } },
                                              [_vm._v("自动")]
                                            )
                                          : _c("a-tag", [_vm._v("手工")]),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      {
                                        staticStyle: { "text-align": "center" },
                                      },
                                      [
                                        _c("a-icon", {
                                          staticStyle: {
                                            color: "#f5222d",
                                            cursor: "pointer",
                                          },
                                          attrs: { type: "delete" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.systemTemplateLines.splice(
                                                idx,
                                                1
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]),
                        ]
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }